// removed by extract-text-webpack-plugin
module.exports = {"prev":"PrevSliderButton_prev--bGjpC","isDisabled":"PrevSliderButton_isDisabled--1dk9t"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/PrevSliderButton/PrevSliderButton.scss
// module id = 2297
// module chunks = 11